import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./generic/components/views/LandingPage/LandingPage";
import { apps } from "./apps/apps";
import { useTheme, ThemeProvider } from "@mui/material/styles";
import { mergeGenericAppConfig } from "./apps/mergeGenericAppConfig";
import PolicyPage from "./pages/PolicyPage";
import PrivacyPolicy from "./generic/components/views/PrivacyPolicy";
import TermsOfService from "./generic/components/views/TermsOfService";
import ContactPageWrapped from "./pages/ContactPage/ContactPageWrapped";
import ListAppsPage from "./pages/ListAppsPage/ListAppsPage";
import PicaBookPrivacyPolicy from "./generic/components/views/PicaBookPrivacyPolicy";
import MixMaxPrivacyPolicy from "./generic/components/views/MixMaxPrivacyPolicy";
import MixMaxTermsOfService from "./generic/components/views/MixMaxTermsOfService";
import CityUnlockPrivacyPolicy from "./generic/components/views/CityUnlockPrivacyPolicy";
import CityUnlockTermsOfService from "./generic/components/views/CityUnlockTermsOfService";
import AnswerMeChildSafetyStandards from "./generic/components/views/AnswerMeChildSafetyStandards";

function App() {
  const theme = useTheme({
    palette: {
      light: {
        main: "#ffffff",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route
            exact
            path={"/"}
            element={
              <div id={"home_page"}>
                <ListAppsPage
                  key={"listAppsPage"}
                  tabTitle={"My Fortuna Apps"}
                  pageTitle={"Welcome to My Fortuna Apps"}
                  subTitle={
                    "You might want to explore some of our current projects below."
                  }
                />
              </div>
            }
          />
          {Array.isArray(apps) &&
            apps.length > 0 &&
            apps.map((app, index) => {
              return (
                <Route
                  exact
                  path={app?.path}
                  element={<LandingPage app={mergeGenericAppConfig({ app })} />}
                  key={app?.path || index}
                />
              );
            })}
          <Route
            exact
            path={"/contact"}
            element={<ContactPageWrapped userContext={"user"} />}
          />
          <Route
            exact
            path={"/business-inquiry"}
            element={
              <ContactPageWrapped
                userContext={"business"}
                headlineMessage={
                  "We are looking forward to working with you on a new mobile app project at My Fortuna. Please contact us with your idea or proposal."
                }
              />
            }
          />
          {Array.isArray(apps) &&
            apps.length > 0 &&
            apps.map((app, index) => {
              const isPicaBook = app?.name === "PicaBook";
              const isMixMax = app?.name === "Mix Max";
              const isCityUnlock = app?.name === "City Unlock";
              let privacyContent = <PrivacyPolicy />;
              if (isPicaBook) {
                privacyContent = <PicaBookPrivacyPolicy />;
              } else if (isMixMax) {
                privacyContent = <MixMaxPrivacyPolicy />;
              } else if (isCityUnlock) {
                privacyContent = <CityUnlockPrivacyPolicy />;
              }
              return (
                <Route
                  exact
                  path={"/privacy-policy" + app?.path}
                  element={
                    <PolicyPage
                      app={app}
                      policyName={"Privacy Policy"}
                      policyContent={privacyContent}
                    />
                  }
                  key={"/privacy-policy" + app?.path}
                />
              );
            })}
          {Array.isArray(apps) &&
            apps.length > 0 &&
            apps.map((app, index) => {
              const isMixMax = app?.name === "Mix Max";
              const isCityUnlock = app?.name === "City Unlock";
              const isAnswerMe = app?.name === "Answer Me";
              let termsContent = (
                <TermsOfService
                  extraSections={
                    isAnswerMe ? <AnswerMeChildSafetyStandards /> : undefined
                  }
                />
              );
              if (isMixMax) {
                termsContent = <MixMaxTermsOfService />;
              } else if (isCityUnlock) {
                termsContent = <CityUnlockTermsOfService />;
              }
              return (
                <Route
                  exact
                  path={"/terms-of-service" + app?.path}
                  element={
                    <PolicyPage
                      app={app}
                      policyName={"Terms of Service"}
                      policyContent={termsContent}
                    />
                  }
                  key={"/terms-of-service" + app?.path}
                />
              );
            })}
          {Array.isArray(apps) &&
            apps.length > 0 &&
            apps.flatMap((app) =>
              (app?.legacyPaths || []).flatMap((legacyPath) =>
                ["", "/privacy-policy", "/terms-of-service"].map((prefix) => (
                  <Route
                    exact
                    path={prefix + legacyPath}
                    element={<Navigate to={prefix + app.path} replace />}
                    key={prefix + legacyPath}
                  />
                ))
              )
            )}
          <Route
            path={"*"}
            element={
              <div id={"not_found_page"}>
                <ListAppsPage
                  key={"notFoundPage"}
                  tabTitle={"404 - Not Found"}
                  pageTitle={"Oops... Page Not Found"}
                  subTitle={
                    "You might want to explore some of My Fortuna's apps."
                  }
                  noindex={true}
                />
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
